<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <div class="page-header">
      <button mat-icon-button routerLink="/users">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h2 class="page-title">Cadastrar Usuário</h2>
        <p class="page-subtitle">Preencha os dados para criar um novo usuário</p>
      </div>
    </div>

    <div class="form-section">
      <app-user-form [create]="true" (loadingChange)="setLoading($event)" />
    </div>

    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/users">
        <mat-icon>close</mat-icon><span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" class="mic-btn-icon-left" (click)="submitForm()">
        <mat-icon>check</mat-icon><span>Confirmar</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>
